module.exports = __webpack_public_path__ + "static/img/showcase_keyg.2fc678b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase_keyg.png
// module id = 754
// module chunks = 1